import { getPaymentMethodsClient } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'

const deletePaymentMethod = async (id: string, accessToken: string) => {
  const payMethodsClient = getPaymentMethodsClient()
  const response = await payMethodsClient.deleteMethod(
    { id },
    buildAxiosRequestConfig({ accessToken })
  )

  return response.data
}

export default deletePaymentMethod
